module.exports = __webpack_public_path__ + "img/lever02.2b7b17ec.png";